export default __webpack_public_path__ + "static/media/img_pindaofenglei.81da655e.png";